<template>

    <div class="container">

        <div id="messages"></div>

        <div class="page-header clearfix h1 mt-10">
                <i class="fa fa-industry"></i>
                Progress
                <div v-if="!loading" class="badge col-filter-badge">
                    {{ table.rows.length }}
                </div>
                <div class="header-buttons">
                    <button @click="clearFilters" class="btn btn-red">
                        Clear Filters
                    </button>
                </div>
                <div class="header-loading-icon">
                    <loading-spinner v-if="loading"></loading-spinner>
                </div>
        </div>

        <div class="row row-filter">

            <div class="col-md-5ths col-filter col-filter-active">
                <div class="col-filter-label">Detail</div>
                <v-select
                        :options="['batches', 'items', 'processes']"
                        :getOptionLabel="toTitleCase"
                        v-model="view"
                        :disabled="loading"
                        :searchable="false"
                        :clearable="false"
                        class="tt-filter"
                ></v-select>
            </div>

            <div class="col-md-5ths col-filter" :class="{'col-filter-active': user_id!==null}">
                <div class="col-filter-label">Person</div>
                <v-select
                        :options="all_users"
                        :reduce="name => name.id"
                        label="name"
                        v-model="user_id"
                        placeholder="All People"
                        :disabled="loading"
                        :searchable="false"
                        :clearable="true"
                        class="tt-filter"
                >
                    <template slot="option" slot-scope="option">
                        <img v-if="option.avatar_url" class="user-avatar-small" :src="option.avatar_url" :alt="option.name">
                        <i v-else class="fa fa-user user-icon"></i>
                        &nbsp; {{ option.name }}
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <img v-if="option.avatar_url" class="user-avatar-small" :src="option.avatar_url" :alt="option.name">
                        <i v-else class="fa fa-user user-icon"></i>
                        &nbsp; {{ option.name }}
                    </template>
                </v-select>
            </div>

            <div class="col-md-5ths col-filter" :class="{'col-filter-active': process_name!==null}">
                <div class="col-filter-label">
                    Process
                    <div v-if="!loading" class="badge col-filter-badge">{{ user_processes.length }}</div>
                </div>
                <v-select
                        @option:created="customProcessFilterEntered"
                        :options="user_processes"
                        v-model="process_name"
                        :reduce="option => option.name"
                        label="name"
                        placeholder="All Processes"
                        :disabled="loading"
                        :searchable="true"
                        :taggable="true"
                        :pushTags="false"
                        :clearable="true"
                        class="tt-filter"
                        :class="{'tt-filter-active': this.process_name!==null}"
                >
                </v-select>
            </div>

            <div class="col-md-5ths col-filter" :class="{'col-filter-active': status!==null}">
                <div class="col-filter-label">
                    Status
                    <div v-if="!loading" class="badge col-filter-badge">{{ user_statuses.length }}</div>
                </div>
                <v-select
                        :options="user_statuses"
                        :getOptionLabel="toTitleCase"
                        v-model="status"
                        placeholder="All Statuses"
                        :disabled="loading"
                        :searchable="false"
                        :clearable="true"
                        class="tt-filter"
                >
                </v-select>
            </div>

            <div class="col-md-5ths col-filter" :class="{'col-filter-active': item_id!==null}">
                <div class="col-filter-label">
                    Item
                    <div v-if="!loading" class="badge col-filter-badge">{{ user_items.length }}</div>
                </div>
                <v-select
                        :options="user_items"
                        :reduce="item => item.id"
                        label="id"
                        v-model="item_id"
                        placeholder="All Items"
                        :disabled="loading"
                        :searchable="true"
                        :clearable="true"
                        inputId="item-filter"
                        class="tt-filter"
                >
                    <template slot="option" slot-scope="option">
                        <b>#{{ option.id }}</b> {{ option.quote.name }}<br/>
                        {{ option.name }}
                    </template>
                </v-select>
            </div>

        </div>


        <div class="row">
            <div class="col-md-12">


                <vue-good-table
                        v-if="firstLoad"
                        @on-selected-rows-change="tableCheckboxesChanged"
                        ref="tt-table"
                        :styleClass="tableClassObject"
                        :columns="table.columns"
                        :rows="table.rows"
                        :sort-options="{
                            enabled: true,
                            initialSortBy: [
                                {field: 'order', type: 'asc'},
                                {field: 'deadline', type: 'asc'},
                            ],
                        }"
                        :selectOptions="{
                            enabled: true,
                            selectOnCheckboxOnly: true,
                            selectionInfoClass: 'table-selection-info',
                            selectionText: 'selected',
                            clearSelectionText: 'clear',
                        }"
                >
                    <div slot="emptystate">
                        <div class="table-empty">
                            <span v-if="loading">
                                Loading...
                            </span>
                            <span v-else>
                                No rows found
                            </span>
                        </div>
                    </div>

                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'users'">
                            <span v-if="props.row.users"
                                  v-for="usr in props.row.users"
                                  :key="usr.id"
                                  @click="avatarClick(usr.id)">
                                <img v-if="usr && usr.avatar_url" class="table-avatar"
                                     data-toggle="tooltip" :title="usr.name" :src="usr.avatar_url" :alt="usr.name">
                                <i v-else-if="usr" class="fa fa-user table-avatar" data-toggle="tooltip" :title="usr.name"></i>
                            </span>
                        </span>
                        <span v-else-if="props.column.field === 'process_name'">
                            <div class="table-txt-wrap">
                                <div class="table-txt-row table-txt-quote" title="Quote & Item IDs">
                                    <i class="fa fa-hashtag"></i>
                                    <div class="table-txt">
                                        <a @click="quoteIdClick(props.row.quote_id)" target="_blank" class="table-txt-a" title="Quote ID">{{props.row.quote_id}}</a>
                                        -
                                        <a @click="itemIdClick(props.row.item_id)" target="_blank" class="table-txt-a" title="Item ID">{{props.row.item_id}}</a>
                                    </div>
                                </div>
                                <div v-if="rowIsBatched(props.row)" class="table-txt-row table-txt-quote" :title="'Batch ID: '+rowBatchHashes(props.row).join(', ')">
                                    <i class="fa fa-cubes batch-icon"></i>
                                    <div class="table-txt">
                                        <a @click="batchHashClick()" class="table-txt-a">Batched ({{rowBatchHashes(props.row).join(', ')}})</a>
                                    </div>
                                </div>
                                <div class="table-txt-row table-txt-client" title="Client">
                                    <i class="fa fa-address-card"></i>
                                    <div class="table-txt">{{props.row.quote.name}}</div>
                                </div>
                                <div class="table-txt-row table-txt-item" title="Item">
                                    <i class="fa fa-box"></i>
                                    <div class="table-txt">{{props.row.item.name}}</div>
                                </div>
                                <div class="table-txt-row table-txt-process table-txt-main" >
                                    <img :src="props.row.process_icon_url" :title="'Process ID '+props.row.id" class="process_icon" />
                                    <div class="table-txt" :title="'Process ID '+props.row.id">
                                        {{props.row.pretty_name}}
                                        <a v-if="props.row.wiki_url.length" :href="props.row.wiki_url"
                                           target="_blank" data-ajax="false"
                                           title="Process Docs" class="process_help">
                                            <i class="fas fa-question-circle"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <span v-if="!user_id" v-for="(num, status) in props.row.statuses"
                               :key="status"
                               :class="'badge badge-status faded badge-status-'+status">
                                    {{status}} x {{num}}
                            </span>
                        </span>
                        <span v-else-if="props.column.field === 'batch_desc'">
                            <div class="table-txt-wrap">
                                <div class="table-txt-row table-txt-quote" :title="'Batch ID: '+rowBatchHashes(props.row).join(', ')">
                                    <i class="fa fa-cubes batch-icon"></i>
                                    <div class="table-txt">
                                        Batch ({{rowBatchHashes(props.row).join(', ')}}):
                                        {{props.row.item_count}} item{{props.row.item_count > 1 ? 's' : ''}},
                                        {{props.row.batched_count}} process{{props.row.batched_count > 1 ? 'es' : ''}}
                                    </div>
                                </div>
                                <div v-for="item in props.row.items" :key="item.id"
                                     class="table-txt-row table-txt-item clickable-item-name table-txt-main"
                                     @click="itemRowClick(item.id)" :title="'Item #'+item.id">
                                    <i class="fa fa-box"></i>
                                    <div class="table-txt">
                                        {{item.name}}
                                        <span class="table-txt-batch-client">[{{item.quote.name}}]</span>
                                    </div>
                                </div>
                            </div>
                            <a v-for="(num, badge_status) in props.row.statuses"
                               :key="badge_status"
                               @click="status = badge_status"
                               :class="'badge badge-status faded badge-status-'+badge_status">
                                    {{badge_status}} x {{num}}
                            </a>
                        </span>
                        <span v-else-if="props.column.field === 'item_name'">
                            <div class="table-txt-wrap">
                                <div class="table-txt-row table-txt-quote" title="Quote & Item IDs">
                                    <i class="fa fa-hashtag"></i>
                                    <div class="table-txt">
                                        <a @click="quoteIdClick(props.row.quote_id)" target="_blank" class="table-txt-a" title="Quote ID">{{props.row.quote_id}}</a>
                                        -
                                        <a @click="itemIdClick(props.row.id)" target="_blank" class="table-txt-a" title="Item ID">{{props.row.id}}</a>
                                    </div>
                                </div>
                                <div v-if="rowIsBatched(props.row)" class="table-txt-row table-txt-quote" :title="'Batch IDs: '+rowBatchHashes(props.row).join(', ')">
                                    <i class="fa fa-cubes batch-icon"></i>
                                    <div class="table-txt">
                                        <a @click="batchHashClick()" class="table-txt-a">Batched ({{rowBatchHashes(props.row).join(', ')}})</a>
                                    </div>
                                </div>
                                <div class="table-txt-row table-txt-client" title="Client">
                                    <i class="fa fa-address-card"></i>
                                    <div class="table-txt">{{props.row.quote.name}}</div>
                                </div>
                                <div class="table-txt-row table-txt-item clickable-item-name table-txt-main" @click="itemRowClick(props.row.id)" title="Item">
                                    <i class="fa fa-box"></i>
                                    <div class="table-txt">{{props.row.name}}</div>
                                </div>
                            </div>
                            <a v-for="(num, status) in props.row.statuses"
                               :key="status"
                               @click="itemRowClick(props.row.id, status)"
                               :class="'badge badge-status faded badge-status-'+status">
                                    {{status}} x {{num}}
                            </a>
                        </span>
                        <span v-else-if="props.column.field === 'assigned_count'">
                            {{props.row.assigned_count}} / {{props.row.work_count}}
                        </span>
                        <span v-else-if="props.column.field === 'batched_count'">
                            {{props.row.batched_count}} / {{props.row.work_count}}
                        </span>
                        <span v-else-if="props.column.field === 'status'">
                            <span v-if="shouldShowStatusSelect(props.row)">
                                <v-select
                                        @input="setStatus(props.row, props.row.status)"
                                        :options="['paused', 'running', 'complete', 'cancelled']"
                                        v-model="props.row.status"
                                        placeholder="Status"
                                        :disabled="loading"
                                        :searchable="false"
                                        :clearable="false"
                                        class="tt-filter large-status"
                                >
                                    <template slot="option" slot-scope="option">
                                        <span :class="'badge badge-status badge-status-'+option.label+' large-status-badge nopoint'">
                                            {{toTitleCase(option.label)}}
                                        </span>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <span :class="'badge badge-status badge-status-'+option.label+' large-status-badge nopoint'">
                                            {{toTitleCase(option.label)}}
                                        </span>
                                    </template>
                                </v-select>
                            </span>
                            <span v-else class="pl-20">
                                <a href="#"
                                   @click="status=props.row.status"
                                   :class="'badge badge-status badge-status-'+props.row.status"
                                >{{props.row.status}}</a>
                            </span>
                        </span>
                        <span v-else-if="props.column.field === 'toggle'">
                            <span v-if="shouldShowToggleButton(props.row)">
                                <button type="button"
                                        class="btn btn-large-status"
                                        :class="'badge-status-'+props.row.status"
                                        @click="setStatus(props.row, props.row.status === 'running' ? 'paused' : 'running')"
                                        :disabled="loading === true">
                                     <span>
                                         <i :class="'fa fa-'+(props.row.status === 'running' ? 'pause' : 'play')+'-circle'"></i>
                                     </span>
                                </button>
                            </span>
                            <span v-else-if="view !== 'batches' && rowIsBatched(props.row)">
                                <button type="button"
                                        class="btn btn-view-batch"
                                        @click="batchHashClick()"
                                        :disabled="loading === true">
                                     <i class="fa fa-eye"></i>&nbsp; Batch
                                </button>
                            </span>
                        </span>
                        <span v-else-if="props.column.field === 'progress'">
                            <timer :row="props.row" :parentView="view" :now="now"></timer>
                            <progress-bar :row="props.row" :now="now"></progress-bar>
                        </span>
                        <span v-else-if="props.column.field === 'deadline'">
                            <button v-if="isUserProcessView"
                                    class="btn btn-new-issue fas fa-exclamation-triangle"
                                    @click="issueModal(props.row.id)"
                            ></button>
                            <i v-if="props.row.deadline === '1970-01-01'" class="fa fa-ban"></i>
                            <span v-else>{{props.formattedRow[props.column.field]}}</span>
                        </span>
                        <span v-else>
                            {{props.formattedRow[props.column.field]}}
                        </span>
                    </template>

                    <div slot="selected-row-actions">
                        <v-select
                                @input="assignUser"
                                :options="all_users.slice(0, all_users.length-3)"
                                :reduce="user => user.id"
                                label="name"
                                placeholder="Assign..."
                                :disabled="loading"
                                :searchable="false"
                                :clearable="false"
                                class="assignment-select"
                        ></v-select>
                        <v-select v-if="selectedRowsHaveRealUsers"
                                @input="unassignUser"
                                :options="selectedRowsUsers"
                                :reduce="user => user.id"
                                label="name"
                                placeholder="Unassign..."
                                :disabled="loading"
                                :searchable="false"
                                :clearable="false"
                                class="assignment-select"
                        ></v-select>
                        <v-select
                                @input="batchSelect"
                                :options="['create', 'individually', 'unbatch']"
                                :getOptionLabel="toTitleCase"
                                label="batch"
                                placeholder="Batch..."
                                :disabled="loading"
                                :searchable="false"
                                :clearable="false"
                                class="assignment-select"
                        ></v-select>
                        <button v-if="view !== 'batches'"
                                type="button"
                                @click="deleteRows"
                                class="btn btn-action btn-action-destructive"
                                :disabled="loading === true">
                            <i class="fa fa-trash-alt"></i> Delete
                        </button>
                    </div>

                </vue-good-table>

                <hr>


            </div>
        </div>

    </div>

</template>

<script>

    let Vue = window.Vue;

    import 'vue-good-table/dist/vue-good-table.css'
    import { VueGoodTable } from 'vue-good-table';
    import api from '../api';
    import Timer from './Timer.vue';
    import ProgressBar from './ProgressBar.vue';
    import LoadingSpinner from './LoadingSpinner';
    import {default as _} from "lodash";
    import vSelect from "vue-select";
    import 'vue-select/dist/vue-select.css';
    import miniToastr from 'mini-toastr';
    import NewIssueForm from './NewIssueForm.vue';
    import VModal from 'vue-js-modal'
    Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

    export default {

        props: {
            all_users: {
                type: Array,
                required: true
            },
            reasons: {
                type: Array,
                required: true
            },
        },

        data: () => ({
            view: 'batches',
            user_id: null,
            item_id: null,
            quote_id: null, // partially implemented
            process_name: null,
            process_name_search: null,
            status: null,
            loading: true,
            firstLoad: false,

            users: [],
            user_items: [],
            user_processes: [],
            user_statuses: [],

            selected_rows: [],

            pingIntervalID: null,

            all_statuses: ['new', 'paused', 'running', 'complete', 'cancelled'],

            app_url: window.location.protocol + "//" + window.location.hostname,


            // from last request to load table data, kept for reference
            progress_data: null,

            now: Math.trunc((new Date()).getTime() / 1000),

            columns: {
                batches: [
                    {
                        label: '',
                        field: 'users',
                        type: 'string',
                        sortable: false,
                        tdClass: 'valign-middle people-td',
                        thClass: 'people-th',
                    },
                    {
                        label: 'Batch',
                        field: 'batch_desc',
                        type: 'string',
                        tdClass: 'valign-middle main-text-td batch-desc-td',
                        thClass: 'batch-desc-th',
                    },
                    {
                        label: 'Progress',
                        field: 'progress',
                        type: 'number',
                        sortable: false,
                        tdClass: 'valign-middle progress-td',
                    },
                    {
                        label: 'Deadline',
                        field: 'deadline',
                        type: 'date',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'MMM Do',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle deadline-td',
                    },
                    {
                        label: 'Order',
                        field: 'order',
                        type: 'number',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle',
                        hidden: true,
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        type: 'string',
                        tdClass: 'valign-middle status-td',
                        hidden: true,
                    },
                    {
                        label: 'Toggle',
                        field: 'toggle',
                        type: 'html',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle toggle-td',
                        sortable: false,
                        hidden: true,
                    },
                ],
                items: [
                    {
                        label: '',
                        field: 'users',
                        type: 'string',
                        sortable: false,
                        tdClass: 'valign-middle people-td',
                        thClass: 'people-th',
                    },
                    {
                        label: 'Qty',
                        field: 'quantity',
                        type: 'number',
                        tdClass: 'vgt-center-align valign-middle quantity-td',
                        thClass: 'vgt-center-align',
                    },
                    {
                        label: 'Item',
                        field: 'item_name',
                        type: 'string',
                        tdClass: 'valign-middle main-text-td',
                    },
                    {
                        label: 'Assigned',
                        field: 'assigned_count',
                        type: 'number',
                        tdClass: 'vgt-center-align valign-middle assigned-td',
                        thClass: 'vgt-center-align',
                    },
                    {
                        label: 'Batched',
                        field: 'batched_count',
                        type: 'number',
                        tdClass: 'vgt-center-align valign-middle assigned-td',
                        thClass: 'vgt-center-align',
                    },
                    {
                        label: 'Time',
                        field: 'seconds',
                        type: 'number',
                        tdClass: 'valign-middle',
                        hidden: true,
                    },
                    {
                        label: 'Progress',
                        field: 'progress',
                        type: 'number',
                        sortable: false,
                        tdClass: 'valign-middle progress-td',
                    },
                    {
                        label: 'Deadline',
                        field: 'deadline',
                        type: 'date',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'MMM Do',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle deadline-td',
                    },
                    {
                        label: 'Created',
                        field: 'created_at',
                        type: 'date',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'MMM Do',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle deadline-td',
                    },
                    {
                        label: 'Order',
                        field: 'order',
                        type: 'number',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle',
                        hidden: true,
                    },
                ],
                processes: [
                    {
                        label: '',
                        field: 'users',
                        type: 'string',
                        sortable: false,
                        tdClass: 'valign-middle people-td',
                        thClass: 'people-th',
                    },
                    {
                        label: 'Qty',
                        field: 'quantity',
                        type: 'number',
                        tdClass: 'vgt-center-align valign-middle quantity-td',
                        thClass: 'vgt-center-align',
                    },
                    {
                        label: 'Process',
                        field: 'process_name',
                        type: 'string',
                        tdClass: 'valign-middle main-text-td',
                    },
                    {
                        label: 'Time',
                        field: 'seconds',
                        type: 'number',
                        tdClass: 'valign-middle',
                        hidden: true,
                    },
                    {
                        label: 'Progress',
                        field: 'progress',
                        type: 'number',
                        sortable: false,
                        tdClass: 'valign-middle progress-td',
                    },
                    {
                        label: 'Deadline',
                        field: 'deadline',
                        type: 'date',
                        dateInputFormat: 'YYYY-MM-DD',
                        dateOutputFormat: 'MMM Do',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle deadline-td',
                    },
                    {
                        label: 'Order',
                        field: 'order',
                        type: 'number',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle',
                        hidden: true,
                    },
                    {
                        label: 'Status',
                        field: 'status',
                        type: 'string',
                        tdClass: 'valign-middle status-td',
                        hidden: true,
                    },
                    {
                        label: 'Toggle',
                        field: 'toggle',
                        type: 'html',
                        thClass: 'vgt-center-align',
                        tdClass: 'vgt-center-align valign-middle toggle-td',
                        sortable: false,
                        hidden: true,
                    },
                ],
            },

            table: {
                columns: [],
                rows: [],
            },

        }),

        components: {
            VueGoodTable,
            Timer,
            ProgressBar,
            vSelect,
            miniToastr,
            VModal,
            NewIssueForm,
            LoadingSpinner,
        },

        mounted() {
            $(document).ready(function() {
                $("#toggle-full-width").click();

                miniToastr.init({
                    timeout: 3000,
                    appendTarget: document.getElementById('messages'),
                });
            });

            // counter for timers
            window.setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
            }, 1000);

            // session keep-alive ping every 30 mins
             window.setInterval(() => {
                api.ping();
            }, 30 * 60 * 1000);
        },

        async created() {
            await this.setFilters();
            await this.loadTable();

            window.Echo.channel('work')
                .listen('WorkCreated', e => {
                    console.log('Broadcast: WorkCreated: loadTable()');
                    this.loadTable();
                })
                .listen('WorkDeleted', e => {
                    console.log('Broadcast: WorkDeleted: loadTable()');
                    this.loadTable();
                })
                .listen('WorkUpdatedBulk', e => {
                    console.log('Broadcast: WorkUpdatedBulk: loadTable()');
                    this.loadTable();
                });
        },

        destroyed() {
            window.Echo.leaveChannel('work');
        },

        methods: {
            issueModal(work_id) {
                this.$modal.show(NewIssueForm, {
                    work_id: work_id,
                    reasons: this.reasons,
                }, {
                    clickToClose: false,
                    width: '60%',
                    height: 'auto',
                    scrollable: true,
                    adaptive: true,
                });
            },
            setFilters() {
                let filters = this.getUrlParams();

                if (typeof filters.view !== "undefined")
                    this.view = filters.view;
                    //this.view = filters.view === 'processes' ? 'processes' : 'items';

                if (typeof filters.user_id !== "undefined") {
                    if( _.indexOf(['unassigned', 'assigned', 'all'], filters.user_id) !== -1 )
                        this.user_id = filters.user_id;
                    else {
                        let user_id_int = parseInt(filters.user_id);
                        this.user_id = user_id_int === 0 ? null : user_id_int;
                    }
                }

                if (typeof filters.item_id !== "undefined") {
                    let item_id_int = parseInt(filters.item_id);
                    this.item_id = item_id_int === 0 ? null : item_id_int;
                }

                if (typeof filters.quote_id !== "undefined") {
                    let quote_id_int = parseInt(filters.quote_id);
                    this.quote_id = quote_id_int === 0 ? null : quote_id_int;
                }

                if (typeof filters.status !== "undefined")
                    this.status = _.indexOf(this.all_statuses, filters.status) === -1 ? null : filters.status;

                if (typeof filters.process_name !== "undefined" && filters.process_name.length)
                    this.process_name = filters.process_name;
            },
            updateUrl() {
                let filters = this.getFilters();
                let self = this;
                let url = 'progress?';
                _.forEach(filters, function (value, key) {

                    // We don't want this (currently un-changeable) var to follow us around and mess up results.
                    // It's only settable on page load from the url.
                    if (key === 'quote_id') {
                        self.quote_id = null;
                        return;
                    }

                    if (typeof value !== "undefined" && value !== null)
                        url += key + '=' + encodeURIComponent(value) + '&';
                });

                history.replaceState(filters, "", url);
            },
            getFilters() {
                return {
                    view: this.view,
                    user_id: this.user_id,
                    item_id: this.item_id,
                    quote_id: this.quote_id,
                    status: this.status,
                    process_name: this.process_name,
                };
            },
            clearFilters() {
                this.view = 'batches';
                this.user_id = null;
                this.item_id = null;
                this.quote_id = null;
                this.status = null;
                this.process_name = null;
            },
            getUrlParams() {
                let params = {},
                    sPageURL = window.location.search.substring(1),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;

                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (typeof sParameterName[0] !== "undefined" && sParameterName[0].length)
                        params[sParameterName[0]] = decodeURIComponent(sParameterName[1]);
                }

                return params;
            },
            loadTable(clearRows=false) {
                if (this.firstLoad && this.loading)
                    return false;

                this.prepareColumns();

                if (this.view === 'batches')
                    this.getBatches(clearRows);
                else if (this.view === 'items')
                    this.getItems(clearRows)
                else if (this.view === 'processes')
                    this.getProcesses(clearRows);

                this.updateUrl();
            },
            prepareColumns() {
                // show play/pause button and status columns only when required
                this.columns.processes[7].hidden = this.columns.processes[8].hidden = ! this.isUserProcessView;
                this.columns.batches[5].hidden = this.columns.batches[6].hidden = ! this.isUserBatchView;
            },
            getAssignedUrlValue() {
                if (this.user_id === 'assigned')
                    return 'true';
                if (this.user_id === 'unassigned')
                    return 'false';
                if (this.user_id === 'all')
                    return 'all';

                return 'true';
            },
            getBatches(clearRows=false) {
                this.loading = true;
                if (clearRows)
                    this.table.rows = [];
                return api.getBatches(
                    this.user_id,
                    this.item_id,
                    this.quote_id,
                    this.status,
                    this.getProcessName(),
                    this.getAssignedUrlValue()
                ).then(data => {
                    this.loading = false;
                    this.firstLoad = true;
                    if (api.responseHasErrors(data)) return;
                    this.table.rows = data.rows;
                    this.setBatchViewStatuses();
                    this.table.columns = this.columns.batches;
                    this.progress_data = data.progress;
                    this.users = data.users;
                    this.user_items = data.rows;
                    this.user_processes = data.user_processes;
                    this.user_statuses = data.user_statuses;
                });
            },
            getItems(clearRows=false) {
                this.loading = true;
                if (clearRows)
                    this.table.rows = [];
                return api.getItems(
                    this.user_id,
                    this.item_id,
                    this.quote_id,
                    this.status,
                    this.getProcessName(),
                    this.getAssignedUrlValue()
                ).then(data => {
                    this.loading = false;
                    this.firstLoad = true;
                    if (api.responseHasErrors(data)) return;
                    this.table.rows = data.rows;
                    this.table.columns = this.columns.items;
                    this.progress_data = data.progress;
                    this.users = data.users;
                    this.user_items = data.rows;
                    this.user_processes = data.user_processes;
                    this.user_statuses = data.user_statuses;
                });
            },
            getProcesses(clearRows=false) {
                this.loading = true;
                if (clearRows)
                    this.table.rows = [];
                return api.getProcesses(
                    this.user_id,
                    this.item_id,
                    this.quote_id,
                    this.status,
                    this.getProcessName(),
                    this.getAssignedUrlValue()
                ).then(data => {
                    this.loading = false;
                    this.firstLoad = true;
                    if (api.responseHasErrors(data)) return;
                    this.table.rows = data.rows;
                    this.table.columns = this.columns.processes;
                    this.progress_data = data.progress;
                    this.users = data.users;
                    this.user_items = data.user_items;
                    this.user_processes = data.user_processes;
                    this.user_statuses = data.user_statuses;
                });
            },
            ucwords(string) {
                return _.startCase(_.toLower(string));
            },
            progressFieldFn(rowObj) {
                return Math.round((rowObj.seconds/rowObj.est_seconds)*100);
            },
            itemRowClick(item_id, status=null) {
                if( this.loading )
                    return false;
                this.item_id = item_id;
                this.view = 'processes';
                if( status !== null )
                    this.status = status;
            },
            avatarClick(user_id) {
                if( this.loading )
                    return false;
                this.user_id = user_id;
            },
            batchHashClick() {
                if( this.loading )
                    return false;
                this.view = 'batches';
            },
            itemIdClick(item_id) {
                if( this.loading )
                    return false;
                this.item_id = item_id;
            },
            quoteIdClick(quote_id) {
                if( this.loading )
                    return false;
                this.quote_id = quote_id;
            },
            rowIsBatched(row) {
                return row.batch_hash || row.batched_count;
            },
            rowBatchHashes(row) {
                if (row.batch_hash)
                    return [row.batch_hash.substr(0,5).toUpperCase()];

                if (row.batched_count)
                    return _.keys(row.batches).map(item => item.substr(0,5).toUpperCase());

                return [];
            },
            setStatus(row, status) {
                if (this.view === 'processes')
                    this.setWorkStatus(row, status);

                else if (this.view === 'batches')
                    this.setBatchStatus(row, status);
            },
            setBatchStatus(row, status) {
                if (this.loading)
                    return false;

                this.loading = true;
                row.status = status;
                return api.updateBatchStatus(row.batch_hash, status, this.user_id).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            setWorkStatus(work, status) {
                if (this.loading)
                    return false;

                // if desired status is same as original status, nothing to do
                if (this.getOriginalWorkRowStatus(work.id) === status)
                    return false;

                this.loading = true;
                work.status = status;
                return api.updateWorkStatus(work.id, status).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            getOriginalWorkRowStatus(work_id) {
                let status = null;

                if (this.view !== 'processes' && this.view !== 'batches')
                    return status;

                _.forEach(this.table.rows, function(row) {
                    if (row.id === work_id) {
                        status = row.status;
                        return false;
                    }
                });

                return status;
            },
            getUserRowCount(user_id) {
                let count = 0;
                let id = user_id === 'unassigned' ? null : user_id;
                _.forEach(this.users, function(user) {
                    if(user.id === id && user.row_count !== undefined) {
                        count = user.row_count;
                    }
                });
                return count;
            },
            tableCheckboxesChanged(params) {
                this.selected_rows = params.selectedRows;
            },
            selectedRowsHaveRealUsers() {
                return this.selectedRowsUserIds().length > 0;
            },
            selectedRowsUserIds() {
                let user_ids = [];
                _.forEach(this.selected_rows, function(row) {
                    _.forEach(row.users, function(user) {
                        if (typeof user.id !== "undefined")
                            user_ids.push(user.id);
                    });
                });
                return user_ids;
            },
            assignUser(user_id) {
                this.loading = true;
                return api.assign(user_id, this.selectedRowIds(), this.view).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            unassignUser(user_id) {
                this.loading = true;
                return api.unassign(user_id, this.selectedRowIds(), this.view).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            batchSelect(method) {
                if (method === 'create')
                    this.batchCreate();
                else if (method === 'individually')
                    this.batchIndividually();
                else if (method === 'unbatch')
                    this.unbatch();
            },
            batchCreate() {
                this.loading = true;
                return api.batchCreate(this.selectedRowIds(), this.view).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            batchIndividually() {
                this.loading = true;
                return api.batchCreate(this.selectedRowIds(), this.view, true).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            unbatch() {
                this.loading = true;
                return api.unbatch(this.selectedRowIds(), this.view).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            deleteRows() {
                let msgView = this.view;
                if (this.selected_rows.length === 1)
                    msgView = this.viewNameSingular();

                if( ! confirm('Really delete '+this.selected_rows.length+' '+msgView+'?') )
                    return;

                this.loading = true;
                return api.delete(this.selectedRowIds(), this.view).then(data => {
                    this.loading = false;
                    if (api.responseHasErrors(data)) return;
                    this.loadTable();
                });
            },
            viewNameSingular()
            {
                if (this.view === 'batches')
                    return 'batch';

                if (this.view === 'items')
                    return 'item';

                if (this.view === 'processes')
                    return 'process';
            },
            selectedRowIds()
            {
                let ids = [];

                _.forEach(this.selected_rows, row => ids.push(this.view === 'batches' ? row.batch_hash : row.id));

                return ids;
            },
            setBatchViewStatuses() {
                if (!this.isUserBatchView)
                    return;

                _.map(this.table.rows, row => row.status = this.getRowStatus(row));
            },
            getRowStatus(row) {
                if (row.status)
                    return row.status

                let currentUser = _.find(row.users, user => user.id === this.user_id);

                return currentUser.status;
            },
            shouldShowStatusSelect(row)
            {
                // 1. show when: user viewing unbatched process
                // 2. show when: user viewing main batch
                return (this.isUserProcessView && ! this.rowIsBatched(row))
                    || this.isUserBatchView;
            },
            shouldShowToggleButton(row)
            {
                // Toggle button isn't needed for statuses like cancelled, complete etc
                if (_.indexOf(['new', 'paused', 'running'], row.status) === -1)
                    return false;

                return (this.isUserProcessView && ! this.rowIsBatched(row))
                    || this.isUserBatchView;
            },
            workMatchesFilters(work) {
                if (this.user_id && work.user_id !== this.user_id)
                    return false;

                let name = this.getProcessName();
                if (name && work.name.indexOf(name.toLowerCase()) === -1)
                    return false;

                if (this.status && work.status !== this.status)
                    return false;

                if (this.item_id && work.item_id !== this.item_id)
                    return false;

                return true;
            },
            itemIdExists(item_id) {
                let exists = false;

                _.forEach(this.user_items, function(item) {
                    if (item.id === item_id) {
                        exists = true;
                        return false;
                    }
                });

                return exists;
            },
            shouldWorkReloadTable(work) {
                return this.workMatchesFilters(work) || this.itemIdExists(work.item_id);
            },
            itemDropdownOptionLabel(item) {
                return `[#${item.id}] ${item.quote.name} ${item.name}`;
            },
            customProcessFilterEntered(event) {
                this.process_name_search = event.name;
            },
            // process_name is undefined when searching with vue-select due to a bug.
            //  So we save the search to a custom data var (in customProcessFilterEntered), and use it when required.
            getProcessName() {
                return typeof this.process_name === "undefined" && typeof this.process_name_search !== "undefined"
                    ? this.process_name_search
                    : this.process_name;
            },
            toTitleCase(str) {
                return str.replace(/\w\S*/g, function(txt){
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                });
            },
            wikiUrl(page_ids) {
                let first_id = page_ids.shift();
                let suggested_ids = page_ids.join(',');
                return this.app_url + '/pages/'+first_id+'?suggested='+suggested_ids;
            },
            openWikiUrl(page_ids) {
                let url = this.wikiUrl(page_ids);
                window.open(url, '_blank');
            },
        },

        computed: {
            tableClassObject() {
                return 'vgt-table condensed';// + (this.loading ? 'load-fade ' : '');
            },
            selectedRowsUsers() {
                let selectedUsers = [];
                if(this.selected_rows.length === 0)
                    return selectedUsers;

                _.forEach(this.selected_rows, function(row) {
                    if (typeof row.users !== "undefined") {
                        _.forEach(row.users, function (user) {
                            selectedUsers.push(user);
                        });
                    }
                });

                return _.uniqBy(selectedUsers, 'id');
            },
            isUserProcessView() {
                return this.view === 'processes'
                    && _.indexOf([
                        'unassigned',
                        'assigned',
                        'all',
                        null,
                        0,
                    ], this.user_id) === -1;
            },
            isUserBatchView() {
                return this.view === 'batches'
                    && _.indexOf([
                        'unassigned',
                        'assigned',
                        'all',
                        null,
                        0,
                    ], this.user_id) === -1;
            },
        },

        watch: {
            user_id: function(newValue, oldValue) {
                if( ! this.loading )
                    this.loadTable();
            },
            item_id: function() {
                if( ! this.loading )
                    this.loadTable();
            },
            quote_id: function() {
                if( ! this.loading )
                    this.loadTable();
            },
            process_name: function() {
                if( ! this.loading )
                    this.loadTable();
            },
            status: function() {
                if( ! this.loading )
                    this.loadTable();
            },
            view: function() {
                if( ! this.loading )
                    this.loadTable();
            },
        },

    }
</script>

<style>
    .load-fade {
        opacity: 0.5;
    }
    .table-item-name {
    }
    .clickable-item-name {
        cursor: pointer;
    }

    .batch-icon {
        color: #20a415 !important;
        font-size: 17px !important;
    }

    .table-txt-wrap {
        color: #5f5f5f;
        font-size: 15px;
    }
    .table-txt-wrap .fa {
        margin-right: 10px;
        width: 25px;
        text-align: center;
        color: #b6b6b6;
        font-size: 16px;
        display: none;
        vertical-align: top;
        margin-top: 2px;
    }
    @media (min-width:992px) {
        .table-txt-wrap .fa {
            display: inline-block;
        }
    }
    .table-txt-row {
        padding: 3px 0;
        display: block;
        white-space: nowrap;
        width: 90%;
    }
    .table-txt {
        display: inline-block;
        white-space: normal;
        width: calc(100% - 40px);
    }
    .table-txt-main {
        color: #292929;
        font-weight: bold;
        font-size: 16px;
    }
    .table-txt-main .fa {
        color: #242424;
    }

    .table-txt-a {
        color: #a8a8a8 !important;
        font-weight: bold !important;
        cursor: pointer;
    }
    .table-txt-batch-client {
        font-weight: normal;
        margin-left: 10px;
    }

    .process_icon {
        width: 22px;
        margin: -3px 10px 0 3px;
    }

    .vgt-responsive {
        padding-bottom: 180px; /* So status dropdowns arn't hidden */
    }

    .tt-filter-active {}

    .tt-filter .vs__selected {
        white-space: nowrap;
    }
    .tt-filter .vs__selected-options {
        overflow: hidden;
        flex-wrap: nowrap;
    }
    .tt-filter .vs__state-active-bg {
        overflow: hidden;
    }


    .row-filter {
        margin-bottom: 20px;
    }
    .col-filter {
        margin-top: 15px;
    }
    @media (min-width:992px) {
        .col-filter {
            margin-top: 0;
        }
    }

    .col-filter-label {
        font-size: 18px;
        margin: 0 0 8px 0;
        color: #505050;
    }
    .col-filter-badge {
        margin: 0 0 0 10px;
        background-color: #bfbfbf;
        color: #fff;
        border-radius: 4px;
        display: inline-block;
        font-size: 12px;
        vertical-align: top;
    }


    .user-icon {
        font-size: 24px;
        color: #818181;
        display: none;
    }
    .user-avatar-small {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        display: none;
    }
    @media (min-width: 1200px) {
        .user-icon, .user-avatar-small {
            display: inline-block;
        }
    }
    .dropdown-badge {
        margin: 0 0 0 10px;
        background-color: #2b4eb1;
        color: #e7eaf5;
        font-size: 70%;
        font-weight: bold;
        padding: 3px 6px;
        border-radius: 5px;
    }



    .badge-status, a.badge-status {
        border-radius: 4px;
        background-color: #9b9696;
        color: #fff;
        margin: 4px 10px 0 0;
        opacity: 1;
    }
    .badge-status:hover, a.badge-status:hover,
    .badge-status:active, a.badge-status:active,
    .badge-status:focus, a.badge-status:focus {
        color: #fff;
        text-decoration: none;
    }
    .badge-status.faded {
        display: none;
        opacity: 0.3;
    }
    .badge-status.faded:hover {
        opacity: 1;
    }
    @media (min-width:992px) {
        .badge-status.faded {
            display: inline-block;
        }
    }
    .badge-status-new, a.badge-status-new {
        background-color: #9b9696;
    }
    .badge-status-new:hover, a.badge-status-new:hover {
        background-color: #777373;
    }
    .badge-status-paused, a.badge-status-paused {
        background-color: #2f74c0;
    }
    .badge-status-paused:hover, a.badge-status-paused:hover {
        background-color: #265e9b;
    }
    .badge-status-running, a.badge-status-running {
        background-color: #f8c227;
        color: #000;
    }
    .badge-status-running:hover, a.badge-status-running:hover {
        background-color: #cea120;
        color: #000;
    }
    .badge-status-complete, a.badge-status-complete {
        background-color: #289b29;
    }
    .badge-status-complete:hover, a.badge-status-complete:hover {
        background-color: #207a21;
    }
    .badge-status-cancelled, a.badge-status-cancelled {
        background-color: #ad4343;
    }
    .badge-status-cancelled:hover, a.badge-status-cancelled:hover {
        background-color: #ad4343;
    }

    .table-avatar {
        width: 22px;
        height: 22px;
        display: block;
        float: left;
        overflow: hidden;
        margin: 2px 4px;
        border-radius: 4px;
        font-size: 22px;
        text-align: center;
        cursor: pointer;
    }
    @media (min-width: 992px) {
        .table-avatar {
            width: 32px;
            height: 32px;
            font-size: 32px;
        }
    }

    .nopoint {
        pointer-events: none;
    }
    .large-status {
    }
    .large-status .vs__open-indicator,
    .large-status .vs__actions,
    .large-status .vs__search {

    }
    .large-status .vs__search {
        padding: 0;
    }
    .large-status .vs__dropdown-toggle {
        border: none;
    }
    .large-status.vs--single.vs--open .vs__selected {
        position: relative;
    }
    .large-status .vs__dropdown-option--selected,
    .large-status .vs__dropdown-option,
    .large-status .vs__dropdown-option--highlight,
    .large-status .vs__dropdown-option--selected:hover,
    .large-status .vs__dropdown-option:hover,
    .large-status .vs__dropdown-option--highlight:hover {
        background-color: #fff;
    }

    .large-status.vs--disabled .vs__clear, .large-status.vs--disabled .vs__dropdown-toggle,
    .large-status.vs--disabled .vs__open-indicator, .large-status.vs--disabled .vs__search,
    .large-status.vs--disabled .vs__selected {
        background-color: #fff;
        opacity: 0.9;
    }
    .btn.disabled, .btn[disabled], fieldset[disabled] .btn {
        filter: alpha(opacity=90) !important;
        opacity: .9 !important;
    }

    .btn-view-batch {
        background-color: #e8e8e8;
        font-weight: 600;
        color: #555;
        border: 1px solid #d7d7d7;
    }
    .btn-view-batch:hover {
        background-color: #b7b7b7;
        color: #292929;
    }

    .vs__dropdown-option {
        padding: 6px 20px;
        font-size: 18px;
    }

    .vs__clear {
        fill: rgba(95, 95, 95, 0.5);
        padding: 0;
        border: 1px solid #e0e0e0;
        background-color: #e7e7e7;
        cursor: pointer;
        margin: 0 4px 0 0;
        width: 25px;
        height: 25px;
        border-radius: 20px;
    }
    @media (min-width: 1200px) {
        .vs__clear {
            margin: 0 12px 0 0;
        }
    }


    .vselect-center-badge {
        /*margin: 4px 10px 0 11px;*/
    }
    .btn-large-status {
        color: #fff;
        font-size: 35px;
        padding: 6px 16px;
        margin: 0 10px 0 0;
    }
    .btn-large-status .fa {
        color: #fff;
    }
    .btn-large-status:hover, .btn-large-status:active .btn-large-status:focus {
        color: #fff;
    }
    .large-status-badge {
        font-size: 15px;
        padding: 5px 10px;
    }
    @media (min-width: 1200px) {
        .large-status-badge {
            font-size: 18px;
        }
    }

    table.vgt-table .valign-middle {
        vertical-align: middle;
    }

    .vgt-table thead th.sorting-asc::after, .vgt-table thead th.sorting-desc::after {
        display: inline-block;
    }
    .vgt-table th.sorting::after {
        right: inherit;
        margin-left: 10px;
    }

    .deadline-td .fa {
        color: #b4b4b4;
    }

    .header-loading-icon {
        display: inline-block;
        float: right;
        width: 200px;
        margin: 5px 0 0 0;
    }

    .mini-toastr {
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
    }
    .mini-toastr-notification__message {
        padding: 0 !important;
    }
    #messages {
        position: relative;
    }
    .mini-toastr__notification.-success {
        background-color: #15831a !important;
    }

    .table-selection-info {
        border: 1px solid #cfcfb9;
        padding: 30px 15px 10px 45px;
        font-size: 16px;
        color: #282908;
        border-radius: 4px 4px 0 0;
        border-bottom: 0;
    }
    .table-selection-info .vgt-selection-info-row__actions {
        width: 70%;
        text-align: right;
        margin: -20px 0 0 0;
    }

    .vs__dropdown-toggle {
        padding: 5px 2px 9px 2px;
    }
    @media (min-width: 1200px) {
        .vs__dropdown-toggle {
            padding: 5px 8px 9px 8px;
        }
    }
    .col-filter-active .vs__dropdown-toggle {
        border: 1px solid #9ea193;
    }
    .col-filter-active .col-filter-label {
        font-weight: bold;
        color: #3f3f3f;
    }

    .assignment-select {
        display: inline-block;
        width: 190px;
        background-color: #fff;
        color: #000;
        font-weight: normal;
        margin: 5px 15px;
    }
    .assignment-select .vs__dropdown-toggle {
        border: 1px solid #939548;
        padding-left: 14px;
        padding-right: 14px;
    }

    .btn-action {
        display: inline-block;
        margin: 1px 15px 5px 15px;
        font-size: 16px;
        padding: 9px 20px;
        border-radius: 4px;
        color: #fff;
    }
    .btn-action i.fa {
        padding-right: 10px;
    }
    .btn-action-destructive {
        background-color: #d85f5f;
        border: 1px solid #b44949;
    }
    .btn-action-destructive:hover,
    .btn-action-destructive:active,
    .btn-action-destructive:focus {
        background-color: #bc0e0e;
        border: 1px solid #3b0a0a;
        color: #fff;
    }

    .table-empty {
        font-size: 25px;
        color: #9f9f9f;
        text-align: center;
        min-height: 60px;
        line-height: 400%;
    }

    .batch-desc-td, .batch-desc-th {
        padding-left: 1.6em !important;
    }

    .people-td {
        width: 65px;
    }
    .quantity-td {
        width: 65px;
    }
    .main-text-td {
        min-width: 300px;
    }
    .assigned-td {
        width: 80px;
    }
    .progress-td {
        width: 150px;
    }
    .status-td {
        width: 150px;
    }

    @media (min-width:1200px) {
        .people-td {
            width: 95px;
        }
        .people-th:after {
            content: "People";
        }
        .quantity-td {
            width: 80px;
        }
        .progress-td {
            width: 20%;
        }
        .status-td {
            width: 180px;
        }
    }

    .process_help {
        margin: 0 6px;
        opacity: 0.5;
        display: inline-block;
    }
    .process_help:hover {
        opacity: 1;
    }

    .header-buttons {
        display: inline-block;
        margin: 0 0 0 40px;
        float: right;
    }
    .header-buttons button,
    .header-buttons a {
        display: inline-block;
        font-weight: bold;
        color: #c5c5c5;
        background-color: #f2f2f2;
        border: 2px solid #dbdbdb;
    }
    .header-buttons .btn-green:hover {
        color: #fff;
        background-color: #1c8a21;
        border-color: #0c4e0f;
    }
    .header-buttons .btn-red:hover {
        color: #fff;
        background-color: #a42424;
        border: 2px solid #531010;
    }

    .v--modal {
        background-color: #fff;
        text-align: left;
        border-radius: 8px;
        box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.6);
        padding: 20px 40px;
    }
    .v--modal-overlay .v--modal-box {
        overflow: visible;
    }

    .btn-new-issue {
        background-color: #fff;
        color: #eaeaea !important;
        font-size: 16px;
        display: block;
        text-align: center;
        width: 100%;
    }
    .btn-new-issue:hover {
        color: #c22e2e !important;
    }

</style>